import curriculum from "../assets/curriculum/data";
import scheduleCurriculum from "../assets/curriculum/scheduleData";
const mixin = {
    data() {
        return {};
    },
    mounted() {
    },
    methods: {
        getScriptIfNotLoaded: function (scriptLocationAndName)
        {
            var len = $('script[src*="' + scriptLocationAndName +'"]').length;

            if (len > 0)
                return;

            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = scriptLocationAndName;
            script.id = 'live_chat_30s';
            script.setAttribute('data-lang', 'vi');
            head.appendChild(script);
        },
        checkMobile: function () {
            if (/Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mimi/i.test(navigator.userAgent)) {
                let widthScreen = screen.width;
                if (widthScreen > 1112) {
                    return false;
                }
                return true;
            }
            return false;
        },
        exportCsv: function (request) {
            this.$api.post("/home/getLoginFlagUser", {
                'loginName': window.sessionStorage.getItem('loginName'),
                'companyId': window.sessionStorage.getItem('companyId')
            }).then(response => {
                if (response.meta.success) {
                    const self = this;
                    var params = {
                        header: request.header || false,
                        titles: request.titles || [],
                        data: request.data || [],
                        name: request.name || 'export.csv',
                        headerName: request.headerName || []
                    }
                    var downloadLink;
                    var csvFile;
                    var type = 'text/csv';
                    const content = params.data.reduce((accumulator, value, index) => {
                        let batp = params.titles.reduce((a, v) => {
                            if (value[v] != null) {
                                a[v] = value[v];
                            }
                            return a;
                        }, {});
                        let entries = Object.entries(batp);
                        let header  = [];
                        let c  = [];
                        header.push("No");
                        c.push(index + 1);
                        let f = entries.reduce((a, [k, v]) => {
                            header.push(k);
                            a.push(v);
                            return a;
                        }, []);
                        c = c.concat(f);
                        if (index == 0 && params.header) {
                            let names = header.reduce((a, v) => {
                                let n = v;
                                let k = params.headerName.findIndex(item => item.key == v);
                                if (k >= 0) {
                                    n = self.$t(params.headerName[k].value);
                                }
                                a.push(n);
                                return a;
                            }, []);
                            names.map((index, key) => {
                                names[key] = '"' + names[key] + '"'
                            })
                            accumulator.push(names.join(","));
                        }
                        c.map((index, key) => {
                            c[key] = '"' + c[key] + '"'
                        })
                        accumulator.push(c.join(","));
                        return accumulator;
                    }, []);
                    csvFile = new Blob(["\ufeff", content.join("\n")], {type: type});
                    downloadLink = document.createElement("a");
                    downloadLink.download = params.name;
                    downloadLink.href = window.URL.createObjectURL(csvFile);
                    downloadLink.style.display = "none";
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                }
            });
        },
        getCurriculum: function (type) {
            return curriculum.filter(item => item.kbn == type);
        },
        getScheduleCurriculum: function (type) {
            return scheduleCurriculum.filter(item => item.kbn == type);
        },
        dataURItoBlob: function(dataURI) {
            const byteString = window.atob(dataURI);
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const int8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteString.length; i++) {
                int8Array[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([int8Array], { type: 'application/pdf'});
            return blob;
        },
        dataURItoBlobImage: function(dataURI) {
            const byteString = window.atob(dataURI);
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const int8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteString.length; i++) {
                int8Array[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([int8Array], { type: 'image/png'});
            return blob;
        },
        dateCompare: function (date1, sign, date2) {
            var day1 = date1.getDate();
            var mon1 = date1.getMonth();
            var year1 = date1.getFullYear();
            var day2 = date2.getDate();
            var mon2 = date2.getMonth();
            var year2 = date2.getFullYear();
            if (sign === '===') {
                if (day1 === day2 && mon1 === mon2 && year1 === year2) return true;
                else return false;
            }
            else if (sign === '>') {
                if (year1 > year2) return true;
                else if (year1 === year2 && mon1 > mon2) return true;
                else if (year1 === year2 && mon1 === mon2 && day1 > day2) return true;
                else return false;
            }    
        },
        getSumMinutes: function (date) {
            return date.getHours() * 60 + date.getMinutes()
        },
        getSumMinutesByStr: function (time) {
            let h = time.substr(0, 2);
            let m = time.substr(3, 5);
            return parseInt(h) * 60 + parseInt(m);
        },
        checkValidUrl: function (url) {
            let expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
            let regex = new RegExp(expression);
            if (url.match(regex)) {
                return true;
            }
            return false;
        },
        checkExam: function (v1, v2) {
            return v1 == null ? v2 : v1;  
        },
        findTagInString: function (html) {
            let str = html.replace(/<br>/g, "");
            let tagName = /<\/[^>]+>$/g.exec(str);
            // let tagName = /<(\w+)\s+\w+.*>/g.exec(str);

            let pos = tagName[0].indexOf(">");
            let name = tagName[0].substring(2, pos);

            // Span
            let tagNameSpan = /span[^>]*>[\s\S]+<\/span>/g.exec(str);

            let fS = null;
            let s = null;

            if (tagNameSpan != null) {
                // style
                let style = /(\w+="(.*?:.*?)")/g.exec(tagNameSpan[0]);

                if (style != null) {
                    // font-size
                    let fontSize = /font-size:.*?$/g.exec(style[style.length - 1]);

                    if (fontSize != null) {    
                        fS  = fontSize[0];
                        s   = style[style.length - 1];
                    }
                }
            }

            return {
                fontSize: fS,
                style: s,
                tagName: name
            }
        }
    },
    computed:{}
};
export default mixin;


// WEBPACK FOOTER //
// ./src/mixins/mixin.js